import luxinLanguages from '@/statics/language.js'
require('@/statics/languages/fa.js')
require('@/statics/languages/dar.js')
require('@/statics/languages/en.js')
require('@/statics/languages/ge.js')
require('@/statics/languages/ru.js')

const GETTERS = {
  language: function(state) {
    return {
      font: 'lxn-text-' + state.language,
      texts : luxinLanguages[state.language],
      floatClass: luxinLanguages[state.language].isRTL ? 'lxn-float-right' : 'lxn-float-left',
      floatClassReverse: luxinLanguages[state.language].isRTL ? 'lxn-float-left' : 'lxn-float-right',
      directionClass: luxinLanguages[state.language].isRTL ? 'lxn-dir-rtl' : 'lxn-dir-ltr',
      textAlignClass: luxinLanguages[state.language].isRTL ? 'lxn-align-right' : 'lxn-align-left'
    }
  },
  isStateSaved: function() {
    return localStorage.getItem("dataSaved") == "true" ? true : false;
  },
  getPhoneNumber: function(state) {
    return state.user.mobileNumber
  },
  getNodeByUUID: function(state) {
    return function (uuid) {
      for(var i = 0; i < state.nodes.length; i++){
        if(state.nodes[i].uuid == uuid){
          state.nodes[i].index = i;
          return state.nodes[i];
        }
      }
      return -1;
    }
  },
  getHubByUUID: function(state) {
    return function (uuid) {
      for(var i = 0; i < state.hubs.length; i++){
        if(state.hubs[i].uuid == uuid){
          state.hubs[i].index = i;
          return state.hubs[i];
        }
      }
      return -1;
    }
  },
  getUserByUUID: function(state) {
    return function (hubIndex, userUUID) {
      for(var i = 0; i < state.hubs[hubIndex].users.length; i++){
        if(state.hubs[hubIndex].users[i].uuid == userUUID){
          state.hubs[hubIndex].users[i].index = i;
          return state.hubs[hubIndex].users[i];
        }
      }
      return -1;
    }
  },
  getScenarioForHubByEventId: function(state) {
    return function (hubUUID, eventId) {
      for(var i = 0; i < state.scenarios.length; i++){
        if(state.scenarios[i].eventIdToWatch == eventId && state.scenarios[i].hubUUID == hubUUID){
          state.scenarios[i].index = i;
          return state.scenarios[i];
        }
      }
      return -1;
    }
  },
  getParameterValue: function(state) {
    return function (nodeIndex, parameterId) {
      var nodeParameters = state.nodes[nodeIndex].rawParameters;
      var parameterLength = nodeParameters.length;
      for(var i = 0; i < parameterLength; i++){
        if(nodeParameters[i].id == parameterId){
          return nodeParameters[i].value;
        }
      }
      return undefined;
    }
  },
  getNodeRssiSnrIcon: function() {
    return function (rssi, snr) {
      console.log(rssi)
      console.log(snr)
      if(snr == undefined){
        if( rssi == undefined){
          return 'offline';
        }else if(rssi < 60){
          return 'rssiLow';
        }else if(rssi < 70){
          return 'rssiMid';
        }else if(rssi >= 70){
          return 'rssiHigh';
        }else{
          return 'offline';
        }
      }else{
        snr = new Int8Array([snr]);
        snr = snr[0];
        if(snr > 0){
          return 'rssiHigh';
        }else if(snr > -6){
          return 'rssiMid';
        }else if(snr >= -38){
          return 'rssiLow';
        }else{
          return 'offline';
        }
      }
    }
  },
  getNodeTemperatureIcon: function() {
    return function (temperature) {
      if( temperature == undefined){
        return 'offline';
      }else if(temperature < 650){
        return 'temperatureLow';
      }else if(temperature < 800){
        return 'temperatureMid';
      }else if(temperature >= 800){
        return 'temperatureHigh';
      }else{
        return 'offline';
      }
    }
  },
  getTemperatureAutomationWidgetByGroupId: function(state) {
    return function (groupId) {
      for(var i = 0; i < state.widgets.length; i++){
        if(state.widgets[i].type == 'temperatureAutomationWidget'){
          if(state.widgets[i].settings.groupId == groupId){
            state.widgets[i].index = i;
            return state.widgets[i];
          }
        }
      }
      return -1;
    }
  },
  getNotificationByEventId: function(state) {
    return function (eventId) {
      for(var i = 0; i < state.notifications.length; i++){
        if(state.notifications[i].eventId == eventId){
          state.notifications[i].index = i
          return state.notifications[i]
        }
      }
      return -1;
    }
  },
   
  getScheduleForHubByEventId: function(state) {
    return function (hubUUID, eventId) {
      for(var i = 0; i < state.schedules.length; i++){
        if(state.schedules[i].eventIdToWatch == eventId && state.schedules[i].hubUUID == hubUUID){
          state.schedules[i].index = i;
          return state.schedules[i];
        }
      }
      return -1;
    }
  },
}
export default GETTERS;